import React, { useState } from "react";
import * as Icon from "react-feather";
import Sectiontitle from "./sectiontitle";
import { trackCustomEvent } from 'gatsby-plugin-google-analytics';

import useContacto from '../hooks/use-contacto';

const Contact = () => {

    const contacto = useContacto();

    const [formdata, setFormdata] = useState({
        name: "",
        email: "",
        subject: "",
        message: ""
    });
    const [error, setError] = useState(false);
    const [message, setMessage] = useState("");
    
    const submitHandler = (event) =>{
        event.preventDefault();        
        if( !formdata.name ){
            setError(true);
            setMessage('Name is required');
        } else if( !formdata.email ){
            setError(true);
            setMessage('Email is required');
        } else if( !formdata.subject ){
            setError(true);
            setMessage('Subject is required');
        } else if( !formdata.message ){
            setError(true);
            setMessage('Message is required');
        } else{
            setError(false);
            setMessage('You message has been sent!!!');
            trackCustomEvent({
                category: "Send Email",
                action: "Click",
                label: "Send Email for GA"
            })
        }
    }

    const handleChange = (event) => {
        setFormdata({
            ...formdata,
            [event.currentTarget.name] : event.currentTarget.value
        })
    }

    const handleAlerts = () => {
        if(error && message){
            return (
                <div className="alert alert-danger mt-4">
                    {message}
                </div>
            )
        } else if(!error && message){
            return (
                <div className="alert alert-success mt-4">
                    {message}
                </div>
            )
        } else{
            return null;
        }
    }

    return (
        <section id="contact">
            <div className="mi-contact-area mi-section mi-padding-top mi-padding-bottom">
                <div className="container">
                    <Sectiontitle title="Contact Me"/>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="mi-contact-formwrapper">
                                <p className="h4">Get In Touch</p>
                                <form action="#" className="mi-form mi-contact-form" onSubmit={submitHandler}>
                                    <div className="mi-form-field">
                                    <label htmlFor="contact-form-name">Enter your name*</label>
                                    <input onChange={handleChange} type="text" name="name" id="contact-form-name" value={formdata.name}/>
                                    </div>
                                    <div className="mi-form-field">
                                    <label htmlFor="contact-form-email">Enter your email*</label>
                                    <input onChange={handleChange} type="text" name="email" id="contact-form-email" value={formdata.email}/>
                                    </div>
                                    <div className="mi-form-field">
                                    <label htmlFor="contact-form-subject">Enter your subject*</label>
                                    <input onChange={handleChange} type="text" name="subject" id="contact-form-subject" value={formdata.subject}/>
                                    </div>
                                    <div className="mi-form-field">
                                    <label htmlFor="contact-form-message">Enter your Message*</label>
                                    <textarea onChange={handleChange} name="message" id="contact-form-message" cols="30" rows="6" value={formdata.message}></textarea>
                                    </div>
                                    <div className="mi-form-field">
                                    <button className="mi-button" type="submit">Send Mail</button>
                                    </div>
                                </form>
                                {handleAlerts()}
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="mi-contact-info">
                                <div className="mi-contact-infoblock">
                                    <span className="mi-contact-infoblock-icon">
                                        <Icon.Phone/>
                                    </span>
                                    <div className="mi-contact-infoblock-content">
                                        <p className="h6">Phone</p>
                                        <p><a href={contacto.telefono}>{contacto.telefono}</a></p>
                                    </div>
                                </div>
                                <div className="mi-contact-infoblock">
                                    <span className="mi-contact-infoblock-icon">
                                        <Icon.Mail/>
                                    </span>
                                    <div className="mi-contact-infoblock-content">
                                        <p className="h6">Email</p>
                                        <p className="color-theme">{contacto.email}</p>
                                    </div>
                                </div>
                                <div className="mi-contact-infoblock">
                                    <span className="mi-contact-infoblock-icon">
                                        <Icon.MapPin/>
                                    </span>
                                    <div className="mi-contact-infoblock-content">
                                        <p className="h6">Address</p>
                                        <p>{contacto.address}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
 
export default Contact;